import { render, staticRenderFns } from "./automodal.vue?vue&type=template&id=72cbf2a8&scoped=true&"
import script from "./automodal.vue?vue&type=script&lang=js&"
export * from "./automodal.vue?vue&type=script&lang=js&"
import style0 from "./automodal.vue?vue&type=style&index=0&id=72cbf2a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72cbf2a8",
  null
  
)

export default component.exports